import React, {useEffect} from "react"
import Modal from "react-modal"
import PropTypes from "prop-types"
import {use_modal} from "../modal_provider"

export const transition_delay = 500

// main div of the Kehub site
Modal.setAppElement(document.getElementById("panel"))

function KenhubModal({
  identifier,
  class_name,
  is_open,
  label,
  title,
  subtitle,
  children,
  on_open = () => { },
  on_close = () => { }
}) {
  const {active_modal, open_modal, close_modal} = use_modal()

  function on_modal_close() {
    close_modal()
    setTimeout(() => {
      if (on_close) on_close()
    }, transition_delay)
  }

  useEffect(() => {
    if (is_open) open_modal(identifier)
  }, [is_open])

  return (
    <Modal
      isOpen={active_modal === identifier}
      className={`modal ${class_name}`}
      portalClassName="react-modal-portal"
      overlayClassName="modal-overlay fade-in"
      bodyOpenClassName="modal-open"
      contentLabel={label}
      onAfterOpen={on_open}
      onRequestClose={on_modal_close}
      closeTimeoutMS={transition_delay}
    >
      {!!title &&
        <div className="modal-header">
          <button className="btn btn-link close" onClick={close_modal}></button>
          <h3 className="modal-title">{title}</h3>
          {subtitle}
        </div>}
      {children}
    </Modal>
  )
}

KenhubModal.propTypes = {
  identifier: PropTypes.string.isRequired,
  class_name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  is_open: PropTypes.bool,
  on_open: PropTypes.func,
  on_close: PropTypes.func
}

export default KenhubModal
